var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.sections),function(ref){
var title = ref.title;
var tip = ref.tip;
var data = ref.data;
var property = ref.property;
var tableLayout = ref.tableLayout;
var type = ref.type;
var sectionDisabledMsg = ref.sectionDisabledMsg;
var extraField = ref.extraField;
return (!_vm.loading)?_c('table-collapse',{key:property,class:_vm.wrapClass,attrs:{"type":type,"table-data":data,"table-layout":tableLayout,"title":title,"extraField":extraField,"show-content":_vm.getPropValue(property),"tip":tip,"sectionDisabledMsg":sectionDisabledMsg},on:{"toggle":function($event){return _vm.toggleDisplaySection({property: property})}}}):_c('div',{class:_vm.wrapClass},[_c('loading')],1)}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-694d4a76","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/record-details/credentials/CollapsedCredentialSections.vue
// module id = null
// module chunks = 